export default {
  DATE_FORMAT: "DD.MM.YYYY",
  DATE_IN_HISTORY: "DD.MM.YYYY HH:mm:ss",
  TIME_TO_REFRESH: 300000, // 300000ms == 5 min.
};
